import { Box, Typography } from '@mui/material';

import { useLanguage } from '../../hooks';
import { WomanSecurityIllustration } from '../../illustrations';

const customStyles = {
  mainHeading: {
    fontFamily: 'Noto Sans',
    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '0%',
    textAlign: 'center',
    '@media (max-width: 600px)': {
      fontSize: '14px',
      lineHeight: '22px',
    },
  },
  description: {
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontStyle: 'Regular',
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0%',
    textAlign: 'center',
  },
  successIcon: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '40px',
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
  successIconSvg: {
    width: '163px',
    height: '163px',
  },
};

interface MfaActivateProps {
  settingsMode: 'optional' | 'mandatory' | 'disabled';
}

export const MfaActivate = ({ settingsMode }: MfaActivateProps) => {
  const lang = useLanguage();
  if (settingsMode === 'disabled') {
    return <></>;
  }

  return (
    <Box sx={customStyles.successContainer}>
      <Box sx={customStyles.successIcon}>
        <WomanSecurityIllustration sx={customStyles.successIconSvg} />
      </Box>
      <Typography sx={customStyles.mainHeading}>
        {settingsMode === 'optional' ? lang.mfa.protectAccount : lang.mfa.organizationRequires}
      </Typography>
      <Typography sx={customStyles.description}>
        {settingsMode === 'optional'
          ? lang.mfa.protectAccountDescription
          : lang.mfa.organizationRequiresDescription}
      </Typography>
    </Box>
  );
};
